module.exports = __webpack_public_path__ + "img/20beecoins.e86fa34f.svg";